import { IContextMenuProps } from './context-menu.types';
import styles from './context-menu.module.css';
import React, { useRef, useState } from 'react';
import classNames from 'classnames';

export const ContextMenu = ({
  children,
  items,
  onAction,
}: React.PropsWithChildren<IContextMenuProps>) => {
  const [isActive, setIsActive] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const positionMenu = (activating: boolean) => {
    if (menuRef.current && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      menuRef.current.style.paddingTop = `${rect.height}px`;
      setIsActive(activating);
    }
  };

  return (
    <div
      ref={containerRef}
      className={styles.container}
      onClick={() => {
        positionMenu(!isActive);
      }}
    >
      {children}
      <div
        className={`${styles.menuContainer} ${
          isActive ? styles.menuActive : ''
        }`}
        ref={menuRef}
        onMouseLeave={() => {
          positionMenu(false);
        }}
      >
        <ul className={styles.menu}>
          {items.map((item, i) => (
            <li
              key={i}
              className={classNames(styles.item, {
                [styles['item--danger']]: (item?.type ?? 'normal') === 'danger',
              })}
              onClick={() => {
                onAction?.(item.value, item);
                item.action?.();
              }}
            >
              <span>{item.display}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
